<template>
    <modal :adaptive="true" height="auto" name="update-sub-user" @before-open="beforeOpen">
        <d-row v-if="userData">
            <d-col lg="12">
                <d-card class="card-small card-post">
                    <d-card-body>
                        <h6>Update sub user</h6>
                        <d-row class="d-flex justify-content-center">
                            <d-col lg="12">
                                <d-form id="usersForm" @submit.prevent="updateSubUser()">
                                    <d-form-row class="mt-3">
                                        <d-col
                                            class="form-group"
                                            md="12"
                                        >
                                            <label for="email">
                                                Email
                                            </label>
                                            <d-form-input
                                                v-model="userData.email"
                                                type="email"
                                                id="email"
                                                placeholder="Enter user email"
                                                required
                                            />
                                        </d-col>

                                        <d-col
                                            class="form-group"
                                            md="12"
                                        >
                                            <label for="first_name">
                                                First name
                                            </label>
                                            <d-form-input
                                                v-model="userData.first_name"
                                                type="text"
                                                id="first_name"
                                                placeholder="Enter user first name"
                                                required
                                            />
                                        </d-col>

                                        <d-col
                                            class="form-group"
                                            md="12"
                                        >
                                            <label for="last_name">
                                                Last name
                                            </label>
                                            <d-form-input
                                                v-model="userData.last_name"
                                                type="text"
                                                id="last_name"
                                                placeholder="Enter user last name"
                                                required
                                            />
                                        </d-col>

                                        <d-col
                                            class="form-group"
                                            md="12"
                                        >
                                            <label for="phone">
                                                Phone
                                            </label>
                                            <d-form-input
                                                v-model="userData.phone"
                                                type="tel"
                                                id="phone"
                                                placeholder="Enter user number"
                                                required
                                            />
                                        </d-col>

                                        <d-col
                                            class="form-group"
                                            md="12"
                                        >
                                            <label>
                                                Role
                                            </label>
                                            <d-form-select
                                                required
                                                v-model="userData.role"
                                                @change="handleRoleChanged"
                                            >
                                                <option v-for="role in acceptableRoles" :value="role.slug">
                                                    {{ role.name }}
                                                </option>
                                            </d-form-select>
                                        </d-col>

                                        <d-col v-if="['regular-user', 'experienced-user'].includes(userData.role)"
                                               class="form-group" md="12">
                                            <label>Viewing domains</label>
                                            <b-form-select
                                                multiple
                                                :select-size="3"
                                                v-model="websites"
                                            >
                                                <option
                                                    v-for="item in userInfo.websites"
                                                    :key="item.id"
                                                    :value="item.id"
                                                >
                                                    {{ item.domain }}
                                                </option>
                                            </b-form-select>
                                        </d-col>

                                        <d-col md="12" class="form-group d-flex justify-content-end">
                                            <button type="button" @click="hideModal" class="btn btn-secondary mr-3">
                                                Cancel
                                            </button>
                                            <input value="Update" type="submit" class="btn btn-success">
                                        </d-col>
                                    </d-form-row>
                                </d-form>
                            </d-col>
                        </d-row>
                    </d-card-body>
                </d-card>
            </d-col>
        </d-row>
    </modal>
</template>
<script>
  import notification from '@/mixins/notification';
  import permissions from '../../mixins/permissions';
  import {SubUsersService, ErrorService} from '@/main';

  export default {
    props: ['roles', 'permissions'],
    name: "UpdateSubUserModal",
    mixins: [notification, permissions],

    data() {
      return {
        websites: [],
        userData: null,
      };
    },
    methods: {
      initUser(user) {
        this.userData = {
          id: user.id,
          email: user.email,
          first_name: user.first_name,
          last_name: user.last_name,
          phone: user.phone,
          role: user.role.slug
        }
        this.websites = user.specificPermissions.filter(p => p.permissionable_type === 'website').map(p => p.permissionable_id)
      },

      validateForm() {
        const regExperssion = /^(0|[0-9]\d*)$/
        const regValue = regExperssion.exec(this.userData.phone)
        if (!regValue) {
          this.showNotification('error-notification', 'Wrong phone number', "Phone number should contain only numbers")
          return false
        }
        return true
      },

      trimValues() {
        this.userData.email = this.userData.email.trim()
        this.userData.first_name = this.userData.first_name.trim()
        this.userData.last_name = this.userData.last_name.trim()
        this.userData.phone = this.userData.phone.trim()
      },

      mapPermissions() {
        if (['regular-user', 'experienced-user'].includes(this.userData.role)) {
          const slug = this.userData.role === 'experienced-user' ? this.permissionTypes.websiteWriteSpecific : this.permissionTypes.websiteReadSpecific
          const permissionId = this.permissions.find(p => p.slug === slug).id

          return this.websites.map(websiteId => {
            return {
              permission_id: permissionId,
              permissionable_id: websiteId,
              permissionable_type: 'website'
            }
          })
        }

        return []
      },

      async updateSubUser() {
        if (!this.validateForm()) {
          return
        }
        try {
          this.trimValues()
          this.userData.specific_permissions = this.mapPermissions()
          await SubUsersService.updateSubUser(this.userData)
          this.showNotification('success', '', 'User successfully updated !')
          this.hideModal()
          this.$router.push('/dashboard')
          this.$router.go()
        } catch (e) {
          this.showNotification('error-notification', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
        }
      },

      handleRoleChanged(role) {
        if (['regular-user', 'experienced-user'].includes(role)) {
          this.websites = []
        }
      },

      hideModal() {
        this.$modal.hide('update-sub-user');
      },

      beforeOpen(event) {
        this.initUser(event.params.user)
      }
    },
    computed: {
      userInfo() {
        return this.$store.getters.userInfo
      },
      acceptableRoles() {
        return  this.roles.filter(r => r.name !== 'Super Admin')
      }
    },
  };
</script>
